<!-- "Passwort vergessen?" from the login: ask for the account's address. -->
<main class="onb onb--sheet">

  <header class="onb__head">
    <div class="onb__topbar onb__topbar--split">
      <button class="onb__circle onb__circle--onbrand" type="button" data-id="back" aria-label="<%= _lcs( 'Zurück' ) %>">
        <i class="icon icon--arrow-left"></i>
      </button>
      <span></span>
    </div>
    <p class="belturo-eyebrow onb__head-eyebrow"><%= _lcs( 'Konto' ) %></p>
    <!-- One key, wholly emphasised — same reason as the signup titles. -->
    <h1 class="onb__head-title"><em><%= _lcs( 'Passwort vergessen?' ) %></em></h1>
    <p class="onb__head-sub"><%= _lcs( 'Wir schicken dir einen Link, mit dem du ein neues Passwort vergibst.' ) %></p>
  </header>

  <form class="onb__scroll onb__form" id="forgot-form" autocomplete="on" novalidate>
    <div class="field">
      <label class="field__label" for="forgot-email"><%= _lcs( 'E-Mail' ) %></label>
      <div class="field__control">
        <span class="field__icon"><i class="icon icon--mail"></i></span>
        <input class="field__input" id="forgot-email" name="email" type="email" inputmode="email"
               autocomplete="username" placeholder="name@example.com" required />
      </div>
    </div>

    <p class="auth__error" data-id="forgot-error" role="alert" hidden></p>
  </form>

  <footer class="onb__foot onb__foot--bordered onb__foot--form">
    <button class="btn btn--primary btn--lg btn--block" type="submit" form="forgot-form" data-id="send">
      <%= _lcs( 'Link anfordern' ) %>
    </button>
    <p class="auth__switch onb__switch">
      <a class="auth__link auth__link--strong" href="#" data-id="to-login"><%= _lcs( 'Zurück zur Anmeldung' ) %></a>
    </p>
  </footer>

</main>
